import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import AutomationIcon from "@atlaskit/icon/core/automation";
import CalendarIcon from "@atlaskit/icon/core/calendar";
import ChangesIcon from "@atlaskit/icon/core/changes";
import DataFlowIcon from "@atlaskit/icon/core/data-flow";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components/link/src/link";

import { tabbedHeroSectionTrackChangesMessages } from "../reusable-xflow-hero-component/tabbed-hero-section.messages";

import { ContentTypeImage } from "./content-type-image.tsx";

import type { TabProps, TabType } from "./tab-type.tsx";

type TrackContentTypeProps = TabProps;

export const TrackContentType: TabType = ({}: TrackContentTypeProps) => {
    const intl = useIntl();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { user } = useUserContext();

    return (
        <ContentTypeImage
            imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/27g7egubc3xn45a4r7e0t26d4q2p23r1.webp"
            imageAlt="A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
            title={intl.formatMessage(
                tabbedHeroSectionTrackChangesMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionTrackChangesMessages.contentDescription
            )}
            hideSeparator={true}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionTrackChangesMessages.contentFeaturePoint1
                    ),
                    icon: <ChangesIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionTrackChangesMessages.contentFeaturePoint2
                    ),
                    icon: <DataFlowIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionTrackChangesMessages.contentFeaturePoint3
                    ),
                    icon: <AutomationIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionTrackChangesMessages.contentFeaturePoint4
                    ),
                    icon: <CalendarIcon label="" />
                }
            ]}
            cta={
                // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                <Link
                    href={"/software/jira/service-management"}
                    text={intl.formatMessage(
                        tabbedHeroSectionTrackChangesMessages.contentCta
                    )}
                    type={"primary"}
                    dataEventProps={{
                        "data-product-key": "jiraServiceManagement",
                        "data-event-component": "linkButton",
                        "data-event-container": "tabsMenu",
                        "data-event": "clicked",
                        "data-label": "try-it-out",
                        "data-label-english": "Explore Jira Service Management",
                        "data-track-event":
                            "jsm-pt.content-types.track-changes.cta"
                    }}
                    onClick={() => {
                        createAnalyticsEvent({
                            eventName: "jsm-crossflow-tab-cta-clicked",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "linkButton",
                            actionSubjectId: "jsmCrossFlowHeroSection",
                            attributes: {
                                reactComponent: "TrackContentType",
                                tab: "track-changes",
                                userTeamType:
                                    user["extended_profile"]?.team_type
                            }
                        }).fire();
                    }}
                />
            }
            reverseLayout
        />
    );
};
